var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcongallary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 49,
    viewBox: "0 0 44 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.088 31.949H3.65426C1.63812 31.949 0 30.2994 0 28.2833V3.66571C0 1.64957 1.64957 0 3.65426 0H40.3457C42.3619 0 44 1.64957 44 3.66571V28.2833C44 30.2994 42.3504 31.949 40.3457 31.949H25.912C25.8776 31.949 25.8433 31.9261 25.8204 31.8917L22.6816 25.6142C22.4067 25.0529 21.5933 25.0529 21.3184 25.6142L18.1796 31.8917C18.1567 31.9261 18.1338 31.949 18.088 31.949ZM28.982 10.138C28.982 12.578 30.9638 14.5597 33.4038 14.5597C35.8438 14.5597 37.8256 12.578 37.8256 10.138C37.8256 7.698 35.8438 5.71622 33.4038 5.71622C30.9638 5.71622 28.982 7.698 28.982 10.138ZM38.9711 30.4254H40.3457C41.5142 30.4254 42.4764 29.4632 42.4764 28.2947V3.66571C42.4764 2.49727 41.5142 1.53502 40.3457 1.53502H3.65426C2.48581 1.53502 1.52356 2.49727 1.52356 3.66571V23.8157C1.52356 23.8615 1.54647 23.8959 1.58084 23.9073C1.6152 23.9188 1.66103 23.9073 1.69539 23.8844L13.4829 12.7727C15.3845 10.9857 18.3286 10.9857 20.2301 12.7727L38.9138 30.391C38.9367 30.414 38.9596 30.414 38.9826 30.414L38.9711 30.4254Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7689 36.656H26.955C26.6801 36.656 26.4052 36.4956 26.2677 36.2321L22.0865 27.8468C22.0636 27.8125 22.0407 27.7896 21.9949 27.7896C21.949 27.7896 21.9261 27.8125 21.9032 27.8468L17.7335 36.1978C17.6189 36.4613 17.344 36.6445 17.0347 36.6445H6.22084C4.92639 36.6445 3.74649 37.1715 2.89879 38.0306C2.03964 38.8898 1.5127 40.0582 1.5127 41.3527V44.1707C1.5127 46.7596 3.63194 48.8788 6.22084 48.8788H37.7574C40.3463 48.8788 42.4656 46.7596 42.4656 44.1707V41.3527C42.4656 38.7638 40.3463 36.6445 37.7574 36.6445L37.7689 36.656Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcongallary);
export default __webpack_public_path__ + "static/media/icongallary.745e09f8f2f3054821eb26dbb510ab37.svg";
export { ForwardRef as ReactComponent };